import { render } from "./Home.vue?vue&type=template&id=0bf754dc&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=0bf754dc&lang=less&scoped=true"
/* custom blocks */
import block0 from "@/locales/Home.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuildhome%2Frepo%2Fsrc%2Fviews%2FHome.vue&lang=yml&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.0_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf754dc"]])

export default __exports__